import { useRouter } from '@tanstack/react-router'

import SearchIcon from '@mui/icons-material/Search'
import Button from '@mui/material/Button'

import { RouterButton } from 'Common/components/links/routerLinks'

import ErrorPageLayout from './ErrorPageLayout'

export default function RouteNotFoundPage() {
    const router = useRouter()

    return (
        <ErrorPageLayout
            status={404}
            icon={<SearchIcon />}
            title="We couldn't find that page"
            description="The item you're looking for may have been moved, renamed, or no longer exists. Double-check the link, or head back to your work."
            actions={
                <>
                    <RouterButton to="/mywork" variant="contained">
                        Go to My work
                    </RouterButton>
                    <Button variant="outlined" onClick={() => router.history.back()}>
                        Go back
                    </Button>
                </>
            }
        />
    )
}
